import { Component, Input, Output, EventEmitter, HostBinding, AfterContentInit, OnDestroy } from "@angular/core";
import { TabularService, ITab } from "./tabular.service ";
import { convertToBoolProperty } from "projects/sepidz-web-framework/src/lib/@core/utils/helpers";
@Component({
  selector: "tabular-tabset",
  styleUrls: ["./tabular.component.scss"],
  template: `
    <ssg-tabset
      (oncloseTab)="closeTab($event)"
      (oncloseAllTab)="closeAllTab()"
      (changeTab)="selectTab($event)"
      (onBookMark)="onBookMarkClick($event)"
      (isBookMark)="(isBookMark)"
      isTabsetRouter="true">
      <ssg-tab
        *ngFor="let tab of tabItems; let index = index"
        class="tabmain"
        tabIcon="{{ tab.icon }}"
        active="{{ tab.active }}"
        tabTitle="{{ tab.title }}"
        isCloseable="{{ tab.isCloseable }}">
        <ng-container *ngIf="tab.moduleFactory">
          <ng-container *ngComponentOutlet="tab.componentType; ngModuleFactory: tab.moduleFactory; injector: tab.injector"> </ng-container>
        </ng-container>
        <ng-container *ngIf="!tab.moduleFactory">
          <ng-container *ngComponentOutlet="tab.componentType; injector: tab.injector"> </ng-container>
        </ng-container>
      </ssg-tab>
    </ssg-tabset>
  `,
})
export class TabularComponent implements AfterContentInit, OnDestroy {
  @HostBinding("class.full-width") fullWidthValue: boolean = false;
  @Input() tabItems: Array<ITab> = [];
  @Input() index: number = 0;
  @Input() isBookMark: boolean;
  @Input()
  set fullWidth(val: boolean) {
    this.fullWidthValue = convertToBoolProperty(val);
  }
  @Output() changeTab = new EventEmitter<any>();
  @Output() onBookMark = new EventEmitter<any>();
  @Input() selected = 0;

  constructor(private tabsservice: TabularService) {}
  ngAfterContentInit() {
    const activeTabs = this.tabItems.filter((tab) => tab.active);
    if (activeTabs.length === 0) {
      this.selectTab(0);
    }
  }
  closeTab(index: number) {
    this.tabsservice.close(index);
  }
  closeAllTab() {
    this.tabsservice.closeAll();
    setTimeout(() => this.tabsservice.closeAll(), 0);
  }
  onBookMarkClick($event) {
    this.onBookMark.emit($event);
  }
  selectTab(index: number) {
    this.changeTab.emit(index);
    this.tabsservice.setSelectedTab(index);
  }
  ngOnDestroy(): void {}
}
